import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp } from "@/components/site/Reveal";
import { IMG } from "@/lib/content";

export const PhotoBand = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section ref={ref} data-testid="photo-band" className="relative h-[80vh] min-h-[520px] overflow-hidden bg-[var(--ink)]">
      <motion.img style={{ y, scale: 1.25 }} src={IMG.solarSunset} alt="Commercial rooftop solar at sunset" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-[var(--ink)]/90 via-[var(--ink)]/50 to-transparent" />
      <div className="relative h-full mx-auto max-w-[1440px] px-5 lg:px-10 flex items-center">
        <FadeUp className="max-w-3xl">
          <p className="eyebrow">Own, lease or rent your site</p>
          <blockquote className="mt-6 font-display font-bold uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            “Massively reduce — and in many cases entirely eliminate — a power bill of up to <span className="text-[var(--sun)]">$200,000</span> a year.”
          </blockquote>
          <p className="mt-6 text-slate-300 max-w-lg">Both carwash operators and their landlords can receive the funding — with minimal or no upfront capital outlay.</p>
        </FadeUp>
      </div>
    </section>
  );
};
